import { useEffect, useState } from "react";

function useScript(src) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${src}"]`);

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => setLoaded(true);
      script.onerror = () => console.error(`Failed to load script: ${src}`);
      document.body.appendChild(script);
    } else {
      setLoaded(true);
    }
  }, [src]);

  return loaded;
}

export default useScript;
